import { createAction, props } from "@ngrx/store";
import { APIResponse } from "src/app/core/models/api-response";
import { ISegment, ISegmentFilter } from "../models/segment.model";
import { IPageCount } from "src/app/shared/models/page.model";
import { IInventoryFilterRequest } from "../../produits/models/products.models";

// fetch all segments
export const FetchAllSegments = createAction(
  '[ segments ] - FetchAllSegments',
  props<{ includes?: Array<string> }>()
);
export const FetchAllSegmentsSuccess = createAction(
  '[ segments ] - FetchAllSegments Success',
  props<{ allSegments: ISegment[] }>()
);
export const FetchAllSegmentsError = createAction(
  '[ segments ] - FetchAllSegments Error',
);

// fetch segments
export const FetchSegments = createAction(
  '[ Segments ] - FetchSegments',
  props<{
    page: IPageCount;
    filter?: IInventoryFilterRequest | undefined;
    key?: string | undefined;
  }>()
);
export const FetchSegmentsSuccess = createAction(
  '[ Segments ] - FetchSegments Success ',
  props<{ segments: APIResponse<ISegment> }>()
);
export const FetchSegmentsError = createAction(
  '[ Segments ] - FetchSegments Error',
);

// add segment
export const AddSegment = createAction(
  '[ segments ] - AddSegment',
  props<{ segment: Omit<ISegment, 'id'> }>()
);
export const AddSegmentSuccess = createAction(
  '[ segments ] - AddSegment Success',
  props<{ segment: ISegment }>()
);
export const AddSegmentError = createAction(
  '[ segments ] - AddSegment Error'
);

// update segment
export const UpdateSegment = createAction(
  '[ segments ] - UpdateSegment',
  props<{ id: number, segment: Omit<ISegment, 'id'> }>()
);
export const UpdateSegmentSuccess = createAction(
  '[ segments ] - UpdateSegment Success',
  props<{ segment: ISegment }>()
);
export const UpdateSegmentError = createAction(
  '[ segments ] - UpdateSegment Error'
);
// delete segment
export const DeleteSegments = createAction(
  '[ Segments ] - DeleteSegments',
  props<{ id?: number }>()
);
export const DeleteSegmentsSuccess = createAction(
  '[ Segments ] - DeleteSegments Success'
);
export const DeleteSegmentsError = createAction(
  '[ Segments ] - DeleteSegments Error',
);


//loader actions
export const SetSegmentsLoader = createAction(
  '[ Brands ] - SetLoading',
  props<{ isLoading: boolean }>()
);

export const SetSearchSegmentLoader = createAction(
  '[ Loader ] - SearchLoader',
  props<{ isLoading: boolean }>()
);


// Filters
export const SetSegmentFilter = createAction(
  '[ Filters ] - SetSegmentFilter',
  props<{ keyword: string, advanced: ISegmentFilter | null }>()
);

// search
export const SetSegmentSearch = createAction(
  '[ Search ] - SetSegmentSearch',
  props<{ search: string }>()
);
